<template>
  <div class="process-timeline">
    <h1 class="process-timeline__header">{{ title }}</h1>

    <div class="process-timeline__items" slide-show @change="changeActive">
      <ProcessTimelineItem
        v-for="(item, index) in items"
        :key="item.title"
        :index="index"
        :title="item.title"
        :isActive="activeItem === index"
        :isLast="index === items.length - 1"
        @changeActive="changeActive"
      />
    </div>

    <div class="process-timeline__content">
      <transition :name="transitionName" mode="out-in">
        <ProcessTimelineText :key="activeItem" :content="currentContent" />
      </transition>
    </div>
  </div>
</template>

<script>
// mixins
import SlideShow from "./../mixins/slide-show";

import ProcessTimelineItem from "@/components/ProcessTimelineItem.vue";
import ProcessTimelineText from "@/components/ProcessTimelineText.vue";

export default {
  name: "ProcessTimeline",
  mixins: [SlideShow],
  components: {
    ProcessTimelineItem,
    ProcessTimelineText
  },
  props: {
    content: Object
  },
  data() {
    return {
      title: this.content.title,
      items: this.content.items,
      activeItem: null,
      lastActiveItem: null,
      SLIDE_SHOW_OPTIONS: {
        wrapAround: false,
        cellAlign: "left"
      }
    };
  },
  computed: {
    // ...mapState({
    //   title: state => state.data.aboutPage.processTimeline.title,
    //   items: state => state.data.aboutPage.processTimeline.items
    // }),
    currentContent() {
      return typeof this.activeItem === "number"
        ? this.items.find((item, i) => i === this.activeItem)
        : {};
    },
    transitionName() {
      return this.lastActiveItem < this.activeItem
        ? "slide-from-left"
        : "slide-from-right";
    }
  },
  methods: {
    changeActive(newActive) {
      this.lastActiveItem = this.activeItem;
      this.activeItem = newActive;
    },

    // shared with slide-show mixin
    onSlideChange(int) {
      this.changeActive(int);
    }
  }
};
</script>

<style lang="scss">
@import "../scss/globals.scss";

.slide-from-left-enter-active,
.slide-from-right-enter-active {
  transition: all 0.4s; // used to keep time of the transition

  > * > * {
    transition: opacity 0.4s ease-out, transform 0.4s ease-out;

    &:last-of-type {
      transition-delay: 0.05s;
    }
  }
}

.slide-from-left-leave-active,
.slide-from-right-leave-active {
  > * > * {
    transform: translateX(0);
    opacity: 0;
  }
}

.slide-from-left-enter {
  > * > * {
    transform: translateX(-25px);
    opacity: 0;
  }
}

.slide-from-right-enter {
  > * > * {
    transform: translateX(25px);
    opacity: 0;
  }
}
.slide-from-left-enter-to,
.slide-from-right-enter-to {
  > * > * {
    transform: translateX(0);
    opacity: 1;
  }
}

.process-timeline {
  @extend %page-max-width;
  @extend %page-margin-3-v;

  overflow: hidden;

  &__header {
    @include typeface(expanded);
    @include typeset(display-1);

    @extend %title-margin-3;

    text-align: center;
  }

  &__items {
    margin: 0 $margin1-1;
  }

  &__content {
    min-height: rem(400);
  }
}
</style>
